import { DropDetails } from 'components/well/constants';
import { DrawingType, ROIDrawing, RoiUpdateDetails } from '../constants';
import { useAllSelectedWellDrawingsByType } from 'redux/hooks/well';
import { getNewId } from 'utils/Global';
import { getCanvasPointerPosition } from '../utils';
import TransformPoints from 'components/plateviewer/well/TransformPoints';
import { WellDetailsStates } from 'business/models/CustomModels';

let roiDrawing: RoiUpdateDetails = null;
let isDrawingFirstClick: boolean = false;

function getNewRegionName(rois: ROIDrawing[]) {
  if (!rois?.length) {
    return 'Region 1';
  }

  const roiNumbers = new Set();

  rois.forEach((r) => {
    const roiText = r.regionName.split(' ')[1];
    const roiNum = parseInt(roiText);
    if (!isNaN(roiNum)) {
      roiNumbers.add(roiNum);
    }
  });

  let newRoiNumber = 1;
  while (roiNumbers.has(newRoiNumber)) {
    newRoiNumber++;
  }

  return `Region ${newRoiNumber}`;
}
export const useRoiCreateHandlers = (
  wellDetails: DropDetails | WellDetailsStates,
  regionName: string,
  tpObject: TransformPoints,
) => {
  const allRoiDrawings = useAllSelectedWellDrawingsByType(
    wellDetails.plateID,
    wellDetails.wellNum,
    wellDetails.dropNumber,
    regionName,
    DrawingType.ROI,
  ) as ROIDrawing[];

  const onMouseDown: (e) => { drawing: RoiUpdateDetails; type: DrawingType } = (e) => {
    const { x, y } = getCanvasPointerPosition(e) || {};
    if (!x || !y) {
      return null;
    }
    roiDrawing = {
      id: getNewId(),
      regionName: getNewRegionName(allRoiDrawings),
      x,
      y,
      width: 0,
      height: 0,
      locked: false,
      zIndex: 0,
      isNewDrawing: true,
      imagingEnabled: true,
    };
    isDrawingFirstClick = true;
    return null;
  };

  const onMouseMove: (e) => {
    drawing: RoiUpdateDetails;
    type: DrawingType;
    isDrawingFirstClick: boolean;
  } = (e) => {
    const { x: newX, y: newY } = getCanvasPointerPosition(e);
    const width = newX - roiDrawing.x;
    const height = newY - roiDrawing.y;
    const {
      x: dbXCenterOffset,
      y: dbYCenterOffset,
      width: dbWidth,
      height: dbHeight,
    } = tpObject.convertRectangleDrawingForDb(roiDrawing.x, roiDrawing.y, width, height);
    roiDrawing = {
      ...roiDrawing,
      width: width,
      height: height,
      dbXCenterOffset,
      dbYCenterOffset,
      dbWidth,
      dbHeight,
    };
    const drawingData = {
      drawing: roiDrawing,
      type: DrawingType.ROI,
      isDrawingFirstClick,
    };
    isDrawingFirstClick = false;
    return drawingData;
  };

  const onMouseUp: (e) => { drawing: RoiUpdateDetails; type: DrawingType } = (e) => {
    if (!isDrawingFirstClick) {
      roiDrawing = {
        ...roiDrawing,
        isNewDrawing: false,
      };
      return { drawing: roiDrawing, type: DrawingType.ROI };
    }
    isDrawingFirstClick = false;
    return null;
  };

  return { onMouseDown, onMouseMove, onMouseUp };
};
